import { Injectable } from "@angular/core"
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router"
import { AuthService } from "../services/auth.service"
import { PermissionService } from "../services/permission.service"
import { StationContextService } from "../services/station-context.service"

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private stationContext: StationContextService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Check if user is authenticated first
    if (!this.authService.isLoggedIn()) {
      console.log("[RoleGuard] User not authenticated, redirecting to login")
      this.router.navigate(["/login"])
      return false
    }

    // Get required roles from route data
    const requiredRoles = route.data["roles"] as string[]
    const advertiserOnly = route.data["advertiserOnly"] === true

    if (advertiserOnly && !this.permissionService.isAdvertiserUserOnly()) {
      this.router.navigate(["/unauthorized"])
      return false
    }

    if (!requiredRoles || requiredRoles.length === 0) {
      console.log("[RoleGuard] No roles required, allowing access")
      return true
    }

    const assignmentRoles = this.stationContext
      .getAssignments()
      .map((a) => a.station_role)
    const hasRequiredRole = this.permissionService.meetsRouteRoleRequirement(
      requiredRoles,
      assignmentRoles,
    )

    if (!hasRequiredRole) {
      console.log("[RoleGuard] User does not have required roles:", requiredRoles)
      console.log("[RoleGuard] User current role:", this.permissionService.getCurrentRole())
      this.router.navigate(["/unauthorized"])
      return false
    }

    console.log("[RoleGuard] Access granted for roles:", requiredRoles)
    return true
  }
}
